import { Component, OnInit, ChangeDetectorRef, HostListener, ElementRef, ViewChild,Input
	,Output,EventEmitter } from '@angular/core';
	import { MatDialog } from '@angular/material/dialog';
	import * as _ from 'lodash';
	import { of, Subject,Observable } from 'rxjs';
   	import { ParameterService } from '../../../../../services/parameter.service';
	import { AppService } from '../../../../../services/app.service';

	import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse';
	import { FormControl } from '@angular/forms'
	import { debounceTime, distinctUntilChanged ,startWith,map} from 'rxjs/operators'
	
	@Component({
	  selector: 'atyl-instruction-tabs',
	  templateUrl: './instruction-tabs.component.html',
	  styleUrls: ['./instruction-tabs.component.scss']
	})
	
	export class InstructionTabsComponent implements OnInit {
	
	@Input() eventLoad: Observable<boolean>;
	@Input() dossier:any;
	@Input() tier:any;
	@Input() user: any;
	@Input() tierAccess:number[];
	@Input() userDroits: any = [];
    @Input() type: string;
	
	@Output() refresh = new EventEmitter();
	
	private eventsSubscription: any
	strings: any
	nbInstruction:number=0;
	nbInstructionHisto:number=0;
	eventsInstructionHistoSubject: Subject<boolean> = new Subject<boolean>();
	eventsInstructionSubject: Subject<boolean> = new Subject<boolean>();
	eventInstructionOpen: Subject<number> = new Subject<number>();
	eventsDeleteSubject: Subject<boolean> = new Subject<boolean>();
	
	
	viewDeleteOrNot:boolean=false;
	
	selectedTab: number = 0;

	totalHisotrique: number=0;
	totalHisotriqueWithoutCancel: number=0;
	
	listSubscribe: any[] = [];	
	advanceVisibility:boolean=false;
	loadingFilter:boolean=false;
	
	listProcedure:any[]=[];
	loadProcedure:boolean=false;
	procedureCtrl = new FormControl();
	procedureOptions: Observable<any[]>;
	
	listForm:any[]=[];
    loadForm:boolean=false;
	formCtrl = new FormControl();
	formOptions: Observable<any[]>;
	
	
	listDoc:any[]=[];
	loadDoc:boolean=false;
	docCtrl = new FormControl();
	docOptions: Observable<any[]>;
	
	listCourrier:any[]=[];
	loadCourrier:boolean=false;
	courrierCtrl = new FormControl();
	courrierOptions: Observable<any[]>;

	instructionFilter:any[]=[];
    formFilter:any[]=[];
	courrierFilter:any[]=[];
	documentFilter:any[]=[];	
	
	nbInstructionFilter:number=0;
	instructionsFilter:any[]=[];
	
		constructor(
			private changeDetector: ChangeDetectorRef,
			public dialog: MatDialog,
			private parameterService:ParameterService,
			private appService:AppService
		) { }
	
		ngOnInit() {
			this.eventsSubscription = this.eventLoad.subscribe((loading:boolean) =>{
				setTimeout(()=>{
					this.loadTabs(loading);
				})
			})
			
			this.procedureOptions=this.procedureCtrl.valueChanges.pipe(
			      startWith(''),
			      map(value => this._filter(value,'procedure'))
			);
			
			this.formOptions=this.formCtrl.valueChanges.pipe(
			      startWith(''),
			      map(value => this._filter(value,'formulaire'))
			);
			
			this.courrierOptions=this.courrierCtrl.valueChanges.pipe(
			      startWith(''),
			      map(value => this._filter(value,'courrier'))
			);
			
			this.docOptions=this.docCtrl.valueChanges.pipe(
			      startWith(''),
			      map(value => this._filter(value,'document'))
			);
		}
	
	   ngOnDestroy() {
			this.eventsSubscription.unsubscribe();
			this.listSubscribe.forEach((sub) => {
			      sub.unsubscribe();
			})
			
		}
		
		loadedTab(event:any) {
			console.log('InstructionTabsComponent loadedTab',event);
			if (event.historique) {
				this.totalHisotrique=event.instructions.length;
				this.totalHisotriqueWithoutCancel=0;
				for(let i:number=0;i<event.instructions.length;i++) {
					let ins:any=event.instructions[i];
					if (ins.etape==undefined || (ins.etape!=undefined && ins.etape.ID!="annule"))
						this.totalHisotriqueWithoutCancel++;
				}
					
				
				this.nbInstructionHisto=(this.viewDeleteOrNot) ? this.totalHisotrique : this.totalHisotriqueWithoutCancel ;
				if (event.notify)
					this.eventsInstructionSubject.next(false);
			}   
			else {
				this.nbInstruction=event.instructions.length;
				if (event.notify)
					this.eventsInstructionHistoSubject.next(false);
			}
			this.changeDetector.detectChanges();     
		}

		loadTabs(loading:boolean=true){
			console.log('InstructionTabsComponent loadTabs',loading);
			this.eventsInstructionSubject.next(loading);
			this.eventsInstructionHistoSubject.next(loading);
		}
		
		showOptions(event:any) {
			console.log("InstructionTabsComponent showOptions",this.viewDeleteOrNot);
			//this.viewDeleteOrNot=!this.viewDeleteOrNot;
			this.nbInstructionHisto=(this.viewDeleteOrNot) ? this.totalHisotrique : this.totalHisotriqueWithoutCancel ;
			this.eventsDeleteSubject.next(this.viewDeleteOrNot);
			this.changeDetector.detectChanges(); 
		}
		
		clickAdvance() {
			if (!this.loadForm) {
				let _opts:any={
					onlyForm: true,
					onlyActive: true,
				}
			this.listSubscribe.push(
					this.parameterService.getFormulaireList(_opts).subscribe((res:JSONRpcResponse) => {
							this.loadForm=true;
							if (res.result) {
								this.listForm=res.result;
							}
							this.changeDetector.detectChanges();
		
					})
				);
			}
			if (!this.loadDoc)
				this.listSubscribe.push(
					this.parameterService.getDocumentList().subscribe((res:JSONRpcResponse) => {
							this.loadDoc=true;
							if (res.result) {
								this.listDoc=res.result;
							}
							this.changeDetector.detectChanges();
	
					})
				);	
			if (!this.loadCourrier)
				this.listSubscribe.push(
					this.parameterService.getCourrierList().subscribe((res:JSONRpcResponse) => {
							this.loadCourrier=true;
							if (res.result) {
								this.listCourrier=res.result;
							}
							this.changeDetector.detectChanges();
	
					})
				);	
				if (!this.loadProcedure)
							this.listSubscribe.push(
								this.appService.getTypeInstruction().subscribe((res:JSONRpcResponse) => {
										this.loadProcedure=true;
										if (res.result) {
											
											let proc:any=[];
											for(let i=0;i<res.result.length;i++) {
												if (res.result[i].typeID!=undefined) {
													if ((this.type=="instruction"&& res.result[i].typeID!=1)
														||(this.type=="suivi"&& res.result[i].typeID==1)
														)
														proc.push(res.result[i]);
												}
											}
											this.listProcedure=proc;
										}
										this.changeDetector.detectChanges();

								})
				);		
				
		  	this.advanceVisibility = !this.advanceVisibility;
		  	this.changeDetector.detectChanges();
		}
		_clearFilterInsruction() {
			this.nbInstructionFilter=0;
			this.instructionsFilter=[];
			this.formFilter=[];
			this.documentFilter=[];
			this.courrierFilter=[];
			this.instructionFilter=[];
			
			this.changeDetector.detectChanges();
		}
		
		_getFilterInsruction() {
			this.nbInstructionFilter=0;
			this.instructionsFilter=[];
			this.loadingFilter=true;
			if (this.dossier.ID!=undefined 
				&& (this.formFilter.length>0
					|| this.documentFilter.length>0
					|| this.courrierFilter.length>0
					|| this.instructionFilter.length>0
				)) {
				var searchI = [this.type];
				
				let _options:any={
				  searchI: searchI,
				  content: {
					"instruction":this.idFiy(this.instructionFilter),
					"form": this.idFiy(this.formFilter),
					"document":this.idFiy(this.documentFilter),
					"courrier":this.idFiy(this.courrierFilter),
				  }
				};
			console.log("InstructionTabsComponent filter send",this.dossier.ID,_options)
			this.listSubscribe.push(
				this.appService.
					getDossierInsctructionList(this.dossier.ID,_options)
					.subscribe((res:JSONRpcResponse) => {
						if (res.result && res.result.instructions!=undefined) {
							this.nbInstructionFilter=res.result.instructions.length;
							for(let i:number=0;i<res.result.instructions.length;i++)
								this.instructionsFilter.push(res.result.instructions[i].ID);
							console.log("InstructionTabsComponent filter result",res.result,this.instructionsFilter)
							this.loadingFilter=false;
							this.changeDetector.detectChanges();
						}
					})
				);	
			} else {
				this.loadingFilter=false;
				this.changeDetector.detectChanges();
			}
		}
		
		idFiy(array: any[]) {
			return array.map(item => {
				if (item.ID != undefined) {
					return item.ID
				} else if (item.id != undefined) {
					return item.id
				} else {
					return item
				}
			})
		}
		
		displayAutoProcedureList(value: any) {
			return this.displayAutoList(value,'procedure')
			
		}
		
		displayAutoFormList(value: any) {
			return this.displayAutoList(value,'formulaire')
			
		}
		
		displayAutoCourrierList(value: any) {
			return this.displayAutoList(value,'courrier')
			
		}
		
	    displayAutoDocumentList(value: any) {
			return this.displayAutoList(value,'document')
			
		}
		
        _getList(_type:string) {
			let _lst:any[]=[];
			switch (_type) {
				case "formulaire":
					_lst=this.listForm;
			    	    break;
				case "courrier":
					_lst=this.listCourrier;
					break;	
				case "procedure":
					_lst=this.listProcedure;
					break;	
				case "document":
					_lst=this.listDoc;
					break;						
			}
			return _lst;
		}

		_filter(value: any,_type:string): any[] {
			let _lst:any[]=this._getList(_type);
			
			if (value!=undefined && value && typeof value=="string") {
				console.log("InstructionTabsComponent _filter",value,_type,_lst);
		       let filterValue:any[] = value.toLowerCase().split(" ");
		       
			   
			   
			   
		      return  _lst.filter((elt:any) => {
				  let r:boolean=false;
				  let rb:boolean[]=[];
				  for(let i:number=0;i<filterValue.length;i++) {
					  rb[i]=(filterValue[i].length==0);
				  }
				  let label:string=(_type=="courrier") ? elt.label: elt.libelle;
				  for(let i:number=0;i<filterValue.length;i++) {
					  if (label.toLowerCase().includes(filterValue[i]))
					  		rb[i]=true;
					  	
				  }
				  let nbt:number=0;
				  for(let i:number=0;i<filterValue.length;i++) {
					 if (rb[i])
					   nbt++;
				  } 
				  r=(filterValue.length==nbt);
				  
				//   console.log("_filterConsultations",filterValue,r,label,rb)
				   return r;      
			  } )
		        
		    }

		    return _lst;
		}

		displayAutoList(value: any,_type:string) {
			let _lst:any[]=this._getList(_type);
			console.log("InstructionTabsComponent displayAutoList",value,_type,_lst)
			let label:any="";
			let stop:boolean=false;
			_lst.forEach((d: any) => {
					if (!stop && d.ID==value ){
						stop=true;
						
					    label= (_type=="courrier") ? d.label: d.libelle;
					}
				});

			return label;  
		}

		selectedElt(event:any,_type:string) {
		   
			switch (_type) {
				case "formulaire":
					this.formFilter.push(event.option.value);
			    	    break;
				case "courrier":
					this.courrierFilter.push(event.option.value);
					break;	
				case "procedure":
					this.instructionFilter.push(event.option.value);
					break;	
				case "document":
					this.documentFilter.push(event.option.value);
					break;						
			}
			console.log("InstructionTabsComponent selectedElt",event,_type);
			this._getFilterInsruction();
		}

		removeElt(proc: any,_type:string) {
			let index:number=-1;
			switch (_type) {
				case "formulaire":
					index = this.formFilter.indexOf(proc)
					if (index >= 0) {
						this.formFilter.splice(index, 1)
					}	
			    	    break;
				case "courrier":
					index = this.courrierFilter.indexOf(proc)
					if (index >= 0) {
						this.courrierFilter.splice(index, 1)
					}
					break;	
				case "procedure":
					index = this.instructionFilter.indexOf(proc)
					if (index >= 0) {
						this.instructionFilter.splice(index, 1)
					}	
					break;	
				case "document":
					index = this.documentFilter.indexOf(proc)
					if (index >= 0) {
						this.documentFilter.splice(index, 1)
					}	
					break;						
			}
			
		    console.log("InstructionTabsComponent removeElt",event,_type,index);
			this.changeDetector.detectChanges();
			this._getFilterInsruction();
		}
		
	}
	
	